export default __webpack_public_path__ + "static/example-hortelanos-af4f77071a6ef30b25b753c5e8911ad8.svg";